// extracted by mini-css-extract-plugin
export default {"params":"css_params__K2s1+","types":"css_types__8u5XO","type":"css_type__9oQiq","ranges":"css_ranges__P0LKP"};